import React from 'react';

export default function Icon({ children, textForAccessibility }: { children: JSX.Element; textForAccessibility: string; }): JSX.Element {
  return (
    <>
      {textForAccessibility && <span className="hideAccessibly">{textForAccessibility}</span>}
      {React.cloneElement(children, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'aria-hidden': true,
      })}
    </>
  );
}
